import { MoreVert, NoAccounts } from "@mui/icons-material";
import {
  IconButton,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import React from "react";
import { IResellerSearchResult } from "../../types";

interface Props {
  reseller: IResellerSearchResult;
  onDemoteClick: (uid: string, name: string) => void;
}

const ResellerRow: React.FC<Props> = ({ reseller, onDemoteClick }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const menuOpen = Boolean(anchorEl);

  const name = `${reseller.firstName} ${reseller.lastName}`;

  const handleMenuOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleDemote = () => {
    onDemoteClick(reseller.uid, name);
    handleMenuClose();
  };

  return (
    <TableRow hover>
      <TableCell>{name}</TableCell>
      <TableCell>{reseller.email}</TableCell>
      <TableCell align="center">{reseller.clientsCount}</TableCell>
      <TableCell align="right">
        <IconButton
          size="medium"
          sx={{
            backgroundColor: "grey.200",
            color: "primary.main",
            "&:hover": {
              backgroundColor: "grey.300",
            },
          }}
          onClick={handleMenuOpen}
          aria-label="abrir menu de ações"
        >
          <MoreVert />
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Tooltip title="Remover cargo de revendedor" placement="left">
            <div>
              <MenuItem onClick={handleDemote}>
                <NoAccounts fontSize="small" sx={{ mr: 1 }} />
                Remover Cargo de Revendedor
              </MenuItem>
            </div>
          </Tooltip>
        </Menu>
      </TableCell>
    </TableRow>
  );
};

export default ResellerRow;
